// Сессия пульта (задача D4): событие «Сессия истекла». Его поднимает клиент API на любой 401 (кроме входа и
// выхода), а окно «Сессия истекла» (`session-expired-dialog.tsx`) слушает. Пока окно открыто, повторные 401 —
// от параллельных запросов и опроса — окно второй раз не открывают.
import { useSyncExternalStore } from 'react';

let expired = false;
const expiredListeners = new Set<() => void>();
const stateListeners = new Set<() => void>();

function notifyState(): void {
  for (const listener of stateListeners) listener();
}

/** Подписка на «Сессия истекла»; возвращает отписку. */
export function onSessionExpired(fn: () => void): () => void {
  expiredListeners.add(fn);
  return () => {
    expiredListeners.delete(fn);
  };
}

/** Сессия истекла: открыть окно. Пока оно открыто, повторные вызовы ничего не делают. */
export function emitSessionExpired(): void {
  if (expired) return;
  expired = true;
  for (const listener of expiredListeners) listener();
  notifyState();
}

/** Окно закрыто: вход прошёл или человек вышел. Следующий 401 снова откроет окно. */
export function closeSessionExpired(): void {
  if (!expired) return;
  expired = false;
  notifyState();
}

export function isSessionExpired(): boolean {
  return expired;
}

function subscribe(listener: () => void): () => void {
  stateListeners.add(listener);
  return () => {
    stateListeners.delete(listener);
  };
}

/** Открыто ли окно «Сессия истекла» — для окна и для клавиш (пока окно открыто, клавиши экрана молчат). */
export function useSessionExpired(): boolean {
  return useSyncExternalStore(subscribe, isSessionExpired, isSessionExpired);
}

/** Начальное состояние — для тестов: сессия общая на модуль. */
export function resetSession(): void {
  expiredListeners.clear();
  closeSessionExpired();
}
